import React, { useState, useContext } from "react";
import { Box, TextField, Button, Typography, Paper } from "@mui/material";
import { useNavigate } from "react-router-dom";
import MyContext from "../MyContext/MyContext";

const AdminLogin = () => {
  const { setAdminAuth } = useContext(MyContext);
  const navigate = useNavigate();

  const [form, setForm] = useState({ user: "", pass: "" });

  const handleSubmit = (e) => {
    e.preventDefault();

    // SIMPLE HARD CODED LOGIN (replace later if needed)
    if (form.user === "durga" && form.pass === "1234") {
      localStorage.setItem("adminAuth", "true");
      setAdminAuth(true);
      navigate("/admin"); // <-- THIS WAS MISSING
    } else {
      alert("Invalid Credentials");
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
        background: "#f5f5f5",
      }}
    >
      <Paper sx={{ p: 4, width: 350, textAlign: "center" }}>
        <Typography variant="h5" mb={2}>
          Admin Login
        </Typography>

        <form onSubmit={handleSubmit}>
          <TextField
            fullWidth
            label="Username"
            sx={{ mb: 2 }}
            onChange={(e) => setForm({ ...form, user: e.target.value })}
          />

          <TextField
            fullWidth
            type="password"
            label="Password"
            sx={{ mb: 2 }}
            onChange={(e) => setForm({ ...form, pass: e.target.value })}
          />

          <Button type="submit" variant="contained" fullWidth>
            Login
          </Button>
        </form>
      </Paper>
    </Box>
  );
};

export default AdminLogin;
